<template>
  <div id="idx-lesson" class="c-index">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'index'
  }
</script>

<style>
  @import '../assets/css/app.css';
</style>



// WEBPACK FOOTER //
// src/my/index.vue